// Shared sorting helpers for ticket lists (and reusable by Reports / Dashboards).

// Workflow order used when sorting by status.
export const STATUS_RANK = {
  open: 0, in_progress: 1, pending_user: 2, pending_department: 3,
  resolved: 4, closed: 5, cancelled: 6,
};

const str = (v) => (v == null ? "" : String(v)).toLowerCase();

/**
 * Build a comparator for ticket rows.
 * @param {{key: string, dir: "asc"|"desc"}} sort
 * @param {Record<string, number>} priorityRank  master-order rank per priority key
 */
export function makeTicketComparator(sort, priorityRank = {}) {
  const { key, dir } = sort;
  const mul = dir === "asc" ? 1 : -1;
  return (a, b) => {
    let r = 0;
    switch (key) {
      case "code": r = str(a.code).localeCompare(str(b.code), undefined, { numeric: true }); break;
      case "customer_name": r = str(a.customer_name).localeCompare(str(b.customer_name)); break;
      case "department_name": r = str(a.department_name).localeCompare(str(b.department_name)); break;
      case "owner_email": r = str(a.owner_email).localeCompare(str(b.owner_email)); break;
      case "priority": {
        const ra = priorityRank[a.priority] ?? 999;
        const rb = priorityRank[b.priority] ?? 999;
        r = ra - rb; break;
      }
      case "status": {
        const ra = STATUS_RANK[a.status] ?? 999;
        const rb = STATUS_RANK[b.status] ?? 999;
        r = ra - rb; break;
      }
      case "created_at":
      default:
        r = new Date(a.created_at || 0) - new Date(b.created_at || 0); break;
    }
    // Stable tie-break on created_at.
    if (r === 0) r = new Date(a.created_at || 0) - new Date(b.created_at || 0);
    return r * mul;
  };
}

/** Return a new sorted copy of `tickets`. */
export function sortTickets(tickets, sort, priorityRank = {}) {
  return [...tickets].sort(makeTicketComparator(sort, priorityRank));
}
